import { HttpClient } from '@angular/common/http';
import { normalizeApiBaseUrl } from 'src/app/shared/utils/api-base-url';
import { JSON_HTTP_OPTIONS } from 'src/app/shared/utils/json-http-options';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriberService {

  constructor(private router: Router, private http: HttpClient) { }
InsertSubscriber(data): Observable<any> {
    const body = data ;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Subscriber/subscriber`, body, JSON_HTTP_OPTIONS);
  }

  AuthenticateSubscriber(data): Observable<any> {
    const body = data ;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Subscriber/authenticate-subscriber`, body, JSON_HTTP_OPTIONS);
  }

  SendOTP(data: any): Observable<any> {
    const body = data ;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Subscriber/send-otp`, body, JSON_HTTP_OPTIONS);
  }

  VerifyOTP(data: any): Observable<any> {
    const body = data ;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Subscriber/verify-otp`, body, JSON_HTTP_OPTIONS);
  }

  SetOtpAndEmailForSubscriber(data): Observable<any> {
    const body = data ;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Subscriber/otp-and-email-for-subscriber`, body, JSON_HTTP_OPTIONS);
  }

  ValidateOTPForSubscriber(data): Observable<any> {
    const body = data ;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Subscriber/validate-otp-for-subscriber`, body, JSON_HTTP_OPTIONS);
  }

  UpdateSubscriberPassword(data): Observable<any> {
    const body = data ;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Subscriber/subscriber-password`, body, JSON_HTTP_OPTIONS);
  }

  GetPasswordFromInstituteEmail(data): Observable<any> {
    const body = data ;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Subscriber/password-from-institute-email`, body, JSON_HTTP_OPTIONS);
  }

  GetSubscriberDataForSubscriberID(data): Observable<any> {
    const body = data ;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Subscriber/subscriber-data-for-subscriber-id`, body, JSON_HTTP_OPTIONS);
  }

  UpdateSubscriberDetails(data): Observable<any> {
    const body = data ;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Subscriber/subscriber-details`, body, JSON_HTTP_OPTIONS);
  }
}
